let tangent_selected_product_map;

let default_addToCartText = "ADD TO BAG";
const default_addedToCartText = "ADDED TO BAG!";
const default_subscribtionAddedText = "SUBSCRIPTION ADDED!";
const default_add_all_to_cart_text = "ADD ALL TO BAG";
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

let tangent_client_domain_currency;

// Map variable to store add all to cart links for each sections
let sections_add_to_cart_map={};

// Tab title mapping based on tags
const tabs_title_mapping={}; 
let tangentTags;

// Add default image url here
const tangent_default_selfie_image_url="https://file.tangent.ai/quiz-content/merchants/sambunting/image/7175991160563253-dr_sam.webp";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_client_domain_url = window.location.origin;
const tangentProductSectionsWrapper = document.querySelector("#tangent_product_sections_wrapper"); 
const tangentOtherSectionsWrapper = document.querySelector("#tangent_other_sections_wrapper"); 

// Message for each conditions
const condition_text_mapping = {
    dark_circles: "Prone to dark circles here! Try our <a target='_blank' href='#'><u>Product Name</u></a>.",
    wrinkles: "Prone to wrinkles here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
    rosacea: "Prone to redness here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
    texture: "Prone to texture here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
    darkspots: "Prone to Pigmentation here! Try our <a target='_blank' href='#'><u>Product Name</u></a>",
    acne: "Prone to Blemish here! Try our <a target='_blank' href='#'><u>Product Name</u></a>"
}

let selectedRegimen;
let finalCategory;

window.onload = function() {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
    // Current Page Load URL
    let tangent_client_url = new URL(window.location.href);
    return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
    if (tangent_response_id != null) {
        const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
        fetch(checkout_url)
        .then(data => {
            return data.json();
        })
        .then(response => {
            checkoutDataProcess(response);
            return response;
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    }
}

function checkoutDataProcess(response){
    const tangent_recommended_products = response.products;

    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }
    setElementDisplay("loading-section", "none");

    tangentTags = response.tags;
    generateSkinRoutineContent(tangentTags);

    selectedRegimen = getRegimen(tangentTags);

    if (response["selfie_id"] != null) {
        setElementDisplay("tangent-loading-section", "flex");
        setSelfieId(response["selfie_id"]);
        getSelfieMapping(response["selfie_id"]);

        setElementDisplay("hideHighlight","block");
    }
    else {
        setTangentDefaultSelfie();
    }

    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
        createProductSection(tangent_product_sections, tangent_text_sections);
    }    
  
    if(response.text_sections!=undefined){
        createTextSection(tangent_product_sections,tangent_text_sections);
    }

    populateConcernTags(tangentTags);

    finalCategory = getRegimenMappedCategory(tangentTags);

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
        enableButtonListener();
        loadElementsOnResponseData(); 
        document.getElementById("final_category_name").innerHTML= finalCategory.replace("final_", "");
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
}

function getRegimenMappedCategory(tags){
    const regimenToConcernMap={
        clarity:["regimen_11","regimen_8","regimen_7a","regimen_7"],
        radiance:["regimen_13a","regimen_13","regimen_6","regimen_1","regimen_5","regimen_3","regimen_1a"]
    };

    selectedRegimen = tags.find(tag=>tag.startsWith("regimen_"));

    if(selectedRegimen){
        for(const[concern,regimens]of Object.entries(regimenToConcernMap)){
            if(regimens.includes(selectedRegimen)){
                const finalTag=`final_${concern}`;
                return finalTag;
            }
        }
    }
}

function getRegimen(tags) {
    const regimens = [
        'regimen_1',
        'regimen_11',
        'regimen_13',
        'regimen_13A',
        'regimen_1A',
        'regimen_3',
        'regimen_5',
        'regimen_6',
        'regimen_7',
        'regimen_7A',
        'regimen_8'
    ];
    return tags.find(tag => regimens.includes(tag)) || null;
}

function populateConcernTags(tags) {
    const concernMap = {
        concern_wrinkles:"Wrinkles",
        concern_blemishes:"Blemishes",
        concern_texture:"Texture",
        concern_redness: "Redness",
        concern_uneven_skintone: "Uneven Skintone",
        concern_pigmentation:"Pigmentation",
        concern_radiance:"Radiance",
        secondary_concern_wrinkles:"Wrinkles",
        secondary_concern_blemishes:"Blemishes",
        secondary_concern_texture:"Texture",
        secondary_concern_redness:"Redness",
        secondary_concern_uneven_skintone:"Uneven Skintone",
        secondary_concern_pigmentation:"Pigmentation",
        secondary_concern_radiance:"Radiance"
    };

    const concerns = tags
        .filter(tag => concernMap[tag])
        .map(tag => concernMap[tag]);

    const heading = document.getElementById("tag_based_heading");

    if (concerns.length > 1) {
        if (document.getElementById("primary_concern_tag")) {
            document.getElementById("primary_concern_tag").textContent =
                concerns[0] || "";
        }

        if (document.getElementById("secondary_concern_tag")) {
            document.getElementById("secondary_concern_tag").textContent =
                concerns[1] || "";
        }
    } else if (concerns.length === 1 && heading) {
        heading.innerHTML =
            `Our recommended routine to target your <span id="primary_concern_tag">${concerns[0]}</span>.`;
    }
}

function generateSkinRoutineContent(allTags) {
  if (!Array.isArray(allTags) || allTags.length === 0) return '';

  const concernDisplayMap = {
    wrinkles: 'wrinkles',
    blemishes: 'blemishes',
    texture: 'texture',
    redness: 'redness',
    uneven_skintone: 'uneven skin tone',
    pigmentation: 'pigmentation',
    radiance: 'radiance'
  };

  const primaryConcerns = [];
  const secondaryConcerns = [];

  allTags.forEach((tag) => {
    if (typeof tag !== 'string') return;

    if (tag.startsWith('concern_')) {
      primaryConcerns.push(tag.replace('concern_', ''));
      return;
    }

    if (tag.startsWith('secondary_concern_')) {
      secondaryConcerns.push(tag.replace('secondary_concern_', ''));
    }
  });

  console.log(primaryConcerns);
  console.log(secondaryConcerns);
  const concerns = [...new Set([...primaryConcerns, ...secondaryConcerns])]
    .filter((concern) => concernDisplayMap[concern])
    .map((concern) => concernDisplayMap[concern]);

  if (concerns.length === 0) return '';

  function formatList(list) {
    if (list.length === 1) return list[0];
    if (list.length === 2) return `${list[0]} and ${list[1]}`;
    return `${list.slice(0, -1).join(', ')}, and ${list[list.length - 1]}`;
  }

  function toTitleCase(text) {
    return text.replace(/\b\w/g, (char) => char.toUpperCase());
  }

  const formattedConcerns = formatList(concerns);

  const routineSelfieContent = `
    <div class="tangent-routine-intro">
      <div class="tangent-routine-tags">
        ${concerns.map(function(concern,index){
          return `
            <span class="tangent-routine-pill ${index===0 ? 'active' : ''}">
              ${toTitleCase(concern)}
            </span>
          `;
        }).join('')}
      </div>
    </div>
  `;

  document.getElementById("tangent-skin-routine-content").innerHTML = routineSelfieContent;
}

// Setting Selfie / Default Image
function setTangentDefaultSelfie() {
    const selfieImage = document.getElementById("tangent_selfie_image");
    if (tangent_default_selfie_image_url) {
        setElementDisplay("loading-section", "none");
        setElementDisplay("canvas_img", "block");
        setElementDisplay("tangent_selfie_image", "flex");
        selfieImage.src = tangent_default_selfie_image_url;
        document.getElementById("section_selfie_container_parent").style.borderBottom = "none";
    } else {
        setElementDisplay("tangent_selfie_container", "none");
    }
}


// Selfie Mapping data api call
async function getSelfieMapping(selfie_id) {
    const selfie_api_url = `https://service.tangent.ai/shopify/upload-selfie?selfie_id=${selfie_id}&user=mango`;

    try {
        const res = await fetch(selfie_api_url);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const data = await res.json();
        tangent_facemap_data = data?.selfie_record?.[0]?.facemap;
        if (tangent_facemap_data) {
            // Update scores
            // setScores(tangent_facemap_data.scores);
            createSkinScoreUI(tangent_facemap_data.scores,"score_container");

            // Update selfie image
            const canvasImg = document.getElementById("canvas_img");
            if (canvasImg) canvasImg.src = tangent_facemap_data.url;
        }

        // Hide loading, show image
        setElementDisplay("selfie-loading-section", "none");
        setElementDisplay("canvas_img", "block");

    } catch (err) {
        console.error("Error fetching selfie:", err);
        setElementDisplay("loading-section", "none");
    }
}

// Setting scores below the selfie
function setScores(scores) {
    let scores_present = false;

    const scoreMap = {
        acne: "Blemishes",
        rosacea: "Redness",
        darkspots: "Pigmentation",
        wrinkles: "Wrinkles",
        dark_circles: "DarkCircles",
        texture: "Texture"
    };

    Object.keys(scores).forEach(key => {
        if (scoreMap[key]) {
            const containerId = `${scoreMap[key]}_Score_container`;
            const scoreId = `#${scoreMap[key]}_Score`;
            setElementDisplay(containerId, "flex");
            document.querySelector(scoreId).innerHTML = scores[key] + "%";
            scores_present = true;
        }
    });

    if (scores_present) {
        setElementDisplay("facemap_all_scores_container", "flex");
    }
}


// Toggle - hide higlight button
function hideHightlightButtonDisplayToggle(display){
  document.querySelector("#hideHighlight").style.display=display;
}

// Toggle - show highlight button
function showHighlightButtonDisplayToggle(display) {
  document.querySelector("#showHighlight").style.display=display;  
}

// Toggle - selfie canvas 
function selfieCanvasDisplayToggle(display){
  document.querySelector("#selfie_canvas").style.display=display;  
}

// Toggle hide highlight and show highlight
function toggleHighlight(status){
  if(status){
    hideHightlightButtonDisplayToggle("block");
    showHighlightButtonDisplayToggle("none");
    selfieCanvasDisplayToggle("block");
  }
  else{
    hideHightlightButtonDisplayToggle("none");
    showHighlightButtonDisplayToggle("block");
    selfieCanvasDisplayToggle("none");
  }
}

function createSkinScoreUI(data, containerId) {
    const container = document.getElementById(containerId);

    if (!container || !data) return;

    const { overall, ...metrics } = data;

    const wrapper = document.createElement("div");
    wrapper.className = "skin-score-wrapper";

    wrapper.innerHTML = `
        <h2 class="skin-score-title h2">
            Your Overall Skin Score is ${overall}
        </h2>
        <p class="skin-score-subtitle">
            Each metric is scored from 0 to 100 - the higher the number, the 'healthier' that area of your skin appears. This is a snapshop, not a diagnosis. AI analysis can vary depending on photo quality and lighting.
        </p>
    `;

    const fills = [];

    const getScoreClass = (score) => {
        if (score < 41) return "Focus-Area";
        if (score < 71) return "Good";
        return "Excellent";
    };

    Object.entries(metrics).forEach(([key, value]) => {
        const metricItem = document.createElement("div");
        metricItem.className = "metric-item";

        const label = document.createElement("div");
        label.className = "metric-label";

        let displayName = key
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());

        const displayNameMap = {
            Darkspots: "Pigmentation",
            Rosacea: "Redness",
            Acne: "Blemishes"
        };

        displayName = displayNameMap[displayName] || displayName;
        
        label.textContent = `${displayName} (${value})`;

        const progress = document.createElement("div");
        progress.className = "metric-progress";

        const fill = document.createElement("div");
        fill.className = `metric-fill ${getScoreClass(value)}`;
        fill.dataset.width = value;

        progress.appendChild(fill);
        metricItem.append(label, progress);
        wrapper.appendChild(metricItem);

        fills.push(fill);
    });

    const retryButton = createRetryQuizComponent("/pages/skincare-quiz");
    wrapper.appendChild(retryButton);

    container.innerHTML = "";
    container.appendChild(wrapper);

    requestAnimationFrame(() => {
        fills.forEach((fill, index) => {
            setTimeout(() => {
                fill.style.width = `${fill.dataset.width}%`;
            }, index * 150);
        });
    });
}

function createRetryQuizComponent(redirectUrl) {
    const wrapper = document.createElement("div");
    wrapper.className = "retry-quiz-container";

    const button = document.createElement("button");
    button.className = "retry-quiz-button";
    button.textContent = "Retake Selfie";

    button.addEventListener("click", () => {
        window.location.href = redirectUrl;
    });

    wrapper.appendChild(button);

    return wrapper;
}

function setProductsToView(products, sections, selected_variants) {

    tangent_selected_product_map = {};
    let sectionIndex = 0;

    Object.keys(sections).forEach(section => {

        const product_ids = sections[section];

        let hasMultiple = product_ids.length > 1;
        if(selectedRegimen==="regimen_6"){
            hasMultiple = false;
        }

        const maxItems = selectedRegimen === "regimen_6" ? 1 : 2;

        if (product_ids.length > maxItems) {
            product_ids.splice(maxItems);
        }

        const sectionLoop = hasMultiple
            ? product_ids.map((_, index) => index)
            : [null];

        sectionLoop.forEach(index => {

            const gridId = index !== null
                ? `${section}_${index}_product_grid`
                : `${section}_product_grid`;

            const product_section_grid = document.getElementById(gridId);

            // Skip increment only for second time in section_activate
            if (!(section === "section_activate" && index === 1)) {
                sectionIndex++;
            }

            const fragment = document.createDocumentFragment();

            if(!index){
                index = 0;
            }
            const id = product_ids[index];

            const product = products.find(p => String(p.id) === id);

            const variant = getSelectedVariant(
                product,
                selected_variants[product.id]
            );

            tangent_selected_product_map[product.id] =
                extractShopifyNumericId(variant.id);


            const product_html = getProductHTML(
                product,
                index,
                variant,
                section,
                sections,
                sectionIndex
            );

            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = product_html;

            while (tempDiv.firstChild) {
                fragment.appendChild(tempDiv.firstChild);
            }

            product_section_grid.appendChild(fragment);

        });

    });
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => extractShopifyNumericId(variant.node.id) === selectedVariantId) || productVariants[0].node;
  }
  
  return productVariants[0].node;
}

function getProductCardTextHTML(product) {
    const text = product.product_card_text?.value;
    if (!text) {
        return "";
    }
    return `
        <p class="tangent_product_card_text text-sm">
            ${text}
        </p>
    `;
}

function getKitDescription(){
    const categoryDescriptionMap = {
        final_clarity:"A 2-week routine for blemish-prone skin. Clears breakouts, unclogs pores + fades post-blemish marks.",
        final_radiance: "A 2-week routine for 24/7 glow. Targets fine lines, dullness and pigmentation with five iconic formulas."
    }
    return categoryDescriptionMap[finalCategory];
}

function getProductButtonData(product, variant, sections, section) {
    let buttonClass = "";
    let buttonText = default_addToCartText;

    if (isProductAvailable(product, variant)) {

        updateSectionAllToCartLink(
            sections,
            product.id,
            tangent_selected_product_map[product.id],
            section
        );
    }
    else {
        buttonText = out_of_stock_text;
        buttonClass = "disable-button";
    }

    return {
        buttonClass,
        buttonText
    };
}

function getMiniSetProductHTML(
    product,
    variant,
    variantId,
    variantImageUrl,
    variantProductUrl,
    productCardText,
    buttonClass,
    buttonText,
    section
) {
    return `
        <div class="tangent-product-box">
            <div class="product-card">

                <div class="tangent-product-image-section">
                    <a
                        class="tangent-text-link tangent-product-image-link"
                        target="_blank"
                        href="${variantProductUrl}"
                    >
                        <img
                            src="${variantImageUrl}"
                            class="tangent_product_image"
                            alt="${product.title}"
                        >
                    </a>
                </div>

                <div class="tangent-product-main-content">

                    <div class="tangent-product-header">

                        <p class="product-top-label">
                            Trial Your Routine
                        </p>

                        <div class="tangent-product-title-wrap">
                            <div class="product-title">
                                <h4 class="tangent-product-title">
                                    ${product.title}
                                </h4>
                            </div>
                        </div>

                        ${getStarRatingHTML(product)}

                        <div class="tangent-product-description">
                            ${getKitDescription()}
                        </div>
                        ${getRadianceProductWarning('mini-set')}

                        <div class="product-pricing">
                            <p class="tangent-product-price">
                                £${variant.price} 
                            </p>
                            <p class="striked-price">£72</p>
                        </div>

                    </div>

                    <div class="tangent-product-meta">

                        <button
                            class="tangent-product-add-btn-wrapper btn button tangent_add_to_cart_button ${buttonClass}"
                            id="${variantId}"
                            data-add-to-cart="${variantId}"
                        >
                            ${buttonText}
                        </button>

                    </div>

                </div>
            </div>

            <div>
                ${getCustomStaticContentForMini()}
            </div>

        </div>
    `;
}


function getFullSetProductHTML(
    product,
    variant,
    variantId,
    variantImageUrl,
    variantProductUrl,
    productCardText,
    buttonClass,
    buttonText,
    section
) {

    let discountedPrice = "155";
    let originalPrice = "183"
    let finalButtonText= "View the Radiance Set";
    if(product.title.includes("Clarity")){
        discountedPrice = "141";
        originalPrice = "167"
        finalButtonText= "View the Clarity Set";
    }
    
    return `
        <div class="tangent-product-box">
            <div class="tangent-product-title-wrap">
                <div class="product-title">
                    <h4 class="product-top-label">
                        ${product.title}
                    </h4>
                </div>
            </div>

            <p class="tangent-product-title">
                Your full routine, <i>full-size</i>
            </p>
            <div class="product-card">

                <div class="tangent-product-image-section">
                    <a
                        class="tangent-text-link tangent-product-image-link"
                        target="_blank"
                        href="${variantProductUrl}"
                    >
                        <img
                            src="${variantImageUrl}"
                            class="tangent_product_image"
                            alt="${product.title}"
                        >
                    </a>
                </div>

                <div class="tangent-product-main-content">
                    <div class="routine-price-card">
                        
                        <div id="price-container">
                            <h2 class="routine-price">£${discountedPrice}</h2>
                            <p><s>£${originalPrice}</s></p>
                        </div>
                        <ul class="routine-benefits">
                            <li>Save £26 vs individual</li>
                            <li>Includes routine card</li>
                            <li>Free consultation with our skin experts</li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
        <div class="clarity-set-wrapper">

            <a class="clarity-set-button" href="${variantProductUrl}" target="_blank">
                ${finalButtonText}
                <span class="clarity-set-arrow">→</span>
            </a>

            <p class="clarity-set-note">
                🔒 Full-size sets only available at drsambunting.com
            </p>
            ${getRadianceProductWarning('full-set')}
        </div>
    `;
}

function getDefaultProductHTML(
    product,
    variant,
    variantId,
    variantImageUrl,
    variantProductUrl,
    productCardText,
    buttonClass,
    buttonText,
    index,
    section,
    sectionIndex
) {
    let stepSectionHtml = '<div class="tangent-product-step-section"></div>';
    const sectionName = section.replace("section_", "");
    stepSectionHtml = `<div class="tangent-product-step-section">
        <div class="tangent-product-step-label">STEP ${sectionIndex}: ${sectionName}</div>
    </div>`;
    return `
        <div class="tangent-product-box">
            ${stepSectionHtml}
            <div class="tangent-product-image-section">
                <a
                    id="url_tangent_product_${index}"
                    class="tangent-text-link tangent-product-image-link"
                    target="_blank"
                    href="${variantProductUrl}"
                >
                    <img
                        id="image_tangent_product_${index}"
                        src="${variantImageUrl}"
                        class="tangent_product_image"
                        alt="${product.title}"
                    >
                </a>
            </div>

            <div class="tangent-product-main-content">

                <div class="tangent-product-header">

                    <div class="tangent-product-title-wrap">

                        <div class="product-title">
                            <h4 class="product-card__title bold">
                                ${product.title}
                            </h4>
                        </div>

                        <div class="product-pricing">
                            <p class="price-list text-sm">
                                £${variant.price}
                            </p>
                        </div>

                    </div>

                    <div class="text-subdued text-sm">
                        ${productCardText}
                    </div>

                </div>

                <div class="tangent-product-meta">
                    <div>${getTimeTag(sectionIndex,index)}</div>
                    ${getHowToUseContent(product)}
                    ${getStarRatingHTML(product)}

                    <button
                        class="tangent-product-add-btn-wrapper btn button tangent_add_to_cart_button ${buttonClass}"
                        id="${variantId}"
                        data-add-to-cart="${variantId}"
                    >
                        ${buttonText}
                    </button>

                    ${getSellingPlanButton(
                        product,
                        variantId,
                        buttonClass,
                        section
                    )}
                </div>
            </div>
        </div>
    `;
}

function getHowToUseContent(product) {
    if (document.getElementById(product.id)) {
        const content = document.getElementById(product.id).value;

        return `
            <div class="how-to-use-product-description">
                <p class="title">How to use</p>

                <p
                    id="how_to_use_text_${product.id}"
                    class="text-subdued text-sm how-to-use-text"
                >
                    ${content}
                </p>

                <button
                    type="button"
                    class="how-to-use-toggle"
                    data-target="how_to_use_text_${product.id}"
                    style="display:none;"
                >
                    Read More
                </button>
            </div>
        `;
    }

    return ``;
}

function getProductHTML(
    product,
    index,
    variant,
    section,
    sections,
    sectionIndex
) {

    const variantId = extractShopifyNumericId(variant.id);

    const variantImageUrl = getVariantImage(
        variant,
        product
    );

    const variantProductUrl =
        `${product.onlineStoreUrl}?variant=${variantId}`;

    const productCardText =
        getProductCardTextHTML(product);

    const {
        buttonClass,
        buttonText
    } = getProductButtonData(
        product,
        variant,
        sections,
        section
    );

    if (section === "section_mini_set") {

        return getMiniSetProductHTML(
            product,
            variant,
            variantId,
            variantImageUrl,
            variantProductUrl,
            productCardText,
            buttonClass,
            buttonText,
            section
        );
    }


    if (section === "section_full_set") {

        return getFullSetProductHTML(
            product,
            variant,
            variantId,
            variantImageUrl,
            variantProductUrl,
            productCardText,
            buttonClass,
            buttonText,
            section
        );
    }

    return getDefaultProductHTML(
        product,
        variant,
        variantId,
        variantImageUrl,
        variantProductUrl,
        productCardText,
        buttonClass,
        buttonText,
        index,
        section,
        sectionIndex
    );
}

function getRadianceProductWarning(sectionSet) {
    if (!tangentTags?.includes("regimen_6")) {
        return "";
    }

    const styleClass =
        sectionSet === "full-set"
            ? "full-set-section-warning"
            : "";

    return `
        <p class="radiance-product-warning ${styleClass}">
            <b>Radiance Kit</b> includes <b>Flawless Nightly 2% Retinoid Serum</b>, which shouldn't be used while you're pregnant or breastfeeding - it's one to save for later. The rest of the products in this kit are safe to use during pregnancy and breastfeeding.
        </p>
    `;
}

function getCustomStaticContentForMini(){
    return `
    <div class="min-set-pledge-section">
        <div class="min-product-pledge-top-card">
            <h3>Our 60 day Happiness Guarantee</h3>
            <p>
            If you're not delighted with our products in any way in the first 60 days,
            we'll happily make it right – or fully refund you (excluding shipping).
            <a href="https://drsams.gorgias.help/en-US/dr-sams-60-day-happiness-pledge-your-guide-to-returns-and-refunds-312023">Read our Happiness Guarantee →</a>
            </p>
        </div>

        <div class="min-product-pledge-feature-grid">
            <div class="min-product-pledge-feature-card">
            <div class="min-product-pledge-icon">
                <img src="https://drsambunting.com/cdn/shop/files/SiteIcons_Delivery_1.png"/>
            </div>

            <div class="min-product-pledge-content">
                <h4>FREE DELIVERY</h4>
                <p>On orders £50+ / €60+ / $50+</p>
            </div>
            </div>

            <div class="min-product-pledge-feature-card">
            <div class="min-product-pledge-icon">
                <img src="https://drsambunting.com/cdn/shop/files/SiteIcons_CrueltyFree_1.png"/>
            </div>

            <div class="min-product-pledge-content">
                <h4>CRUELTY-FREE</h4>
                <p>Never tested on animals</p>
            </div>
            </div>
        </div>
    </div>
    `;
}

function getSellingPlanButton(product, variantId, buttonClass, section) {
  if (product?.sellingPlanGroups?.edges?.length > 0) {
    const groupNode = product.sellingPlanGroups.edges[0].node;

    if (groupNode?.sellingPlans?.edges?.length > 0) {
      const planNode = groupNode.sellingPlans.edges[0].node;
      const planId = extractSellingId(planNode.id);
      return `<button class="btn button tangent-product-add-btn-wrapper-subscribe tangent_add_to_cart_button tangent-product-add-btn-subscribe ${buttonClass}" id="${variantId}" data-planid="${planId}" data-section="${section}">
            Save 20% WITH FLAWLESS365
        </button>
        <p class="tangent-subscription-text">Min. commitment of 3 payment cycles. About <a href="https://drsambunting.com/pages/subscriptions" target="_blank">Flawless365</a></p>`
      ;
    }
  }
  return ``;
}


function getStarRatingHTML(product) {

    const rating = Number(product?.reviews_avg_rating?.value);
    const count = Number(product?.reviews_count?.value);

    if (
        isNaN(rating) ||
        isNaN(count) ||
        rating < 0 ||
        rating > 5 ||
        count < 0
    ) {
        return '';
    }

    let starsHTML = '';

    for (let i = 1; i <= 5; i++) {

        let percentage = 0;

        if (rating >= i) {
            percentage = 100;
        }
        else if (rating >= i - 0.5) {
            percentage = 50;
        }

        starsHTML += `
            <i
                aria-hidden="true"
                class="ruk-icon-percentage-star--${percentage}"
            ></i>
        `;
    }

    return `
        <div
            class="ruk_rating_snippet review-stars--sm product-card__reviews"
            style="color:#000;"
            title="${rating} Stars - ${count}"
            aria-label="${rating} Stars - ${count}"
            tabindex="0"
        >

            ${starsHTML}

            <span
                aria-hidden="true"
                class="ruk-rating-snippet-count"
                style="color:#333;"
            >
                (${count})
            </span>

        </div>
    `;
}

function getTimeTag(sectionIndex, index) {

    const amTag = `
        <div class="time-pill morning">
            <span class="time-pill-icon">
                <svg viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="4" fill="currentColor"/>

                    <line x1="12" y1="1.5" x2="12" y2="5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                    <line x1="12" y1="19" x2="12" y2="22.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>

                    <line x1="1.5" y1="12" x2="5" y2="12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                    <line x1="19" y1="12" x2="22.5" y2="12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>

                    <line x1="4.2" y1="4.2" x2="6.8" y2="6.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                    <line x1="17.2" y1="17.2" x2="19.8" y2="19.8" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>

                    <line x1="17.2" y1="6.8" x2="19.8" y2="4.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                    <line x1="4.2" y1="19.8" x2="6.8" y2="17.2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
            </span>

            <span class="time-pill-text">AM</span>
        </div>
    `;

    const pmTag = `
        <div class="time-pill night">
            <span class="time-pill-icon">
                <svg viewBox="0 0 24 24" fill="none">
                    <path
                        d="M16.8 18.5C11.9 18.5 8 14.6 8 9.7C8 7.1 9.1 4.8 10.9 3.2C6.7 3.7 3.5 7.2 3.5 11.5C3.5 16.2 7.3 20 12 20C14.4 20 16.5 19 18 17.4C17.6 17.8 17.2 18.5 16.8 18.5Z"
                        fill="currentColor"
                    />
                </svg>
            </span>

            <span class="time-pill-text">PM</span>
        </div>
    `;

    // Only AM
    if (sectionIndex === 4) {
        return amTag;
    }

    // Split AM / PM
    if (sectionIndex === 2) {
        return index < 1 ? amTag : pmTag;
    }

    // Both
    return amTag + pmTag;
}

function extractShopifyNumericId(gid) {
  if (typeof gid !== 'string') return null;

  const match = gid.match(/\d+$/);
  return match ? match[0] : null;
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status.toLowerCase() !== "active") {
      return false;
  }
  return variant.availableForSale;
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections, product_id, vid) {
    if (!product_sections) return;

    for (const section in product_sections) {
        if (product_sections[section].includes(String(product_id))) {
            // Initialize section if it doesn't exist
            if (!sections_add_to_cart_map[section]) {
                sections_add_to_cart_map[section] = {
                    count: 0,
                    cart_link: tangent_client_domain_url + "/cart/add?",
                    list: []
                };
            }

            // Update section if vid is not already included
            const sectionData = sections_add_to_cart_map[section];
            if (!sectionData.list.includes(vid)) {
                sectionData.count++;
                sectionData.cart_link += `&id[]=${vid}`;
                sectionData.list.push(vid);

                // Show "Add All to Cart" button if more than one product
                const addAllButton = document.getElementById(`${section}_add_all_to_cart`);
                if (addAllButton) {
                    addAllButton.style.display = sectionData.count > 1 ? "block" : "none";
                }
            }
        }
    }
}


const getVariantImage = (variant, product) => {
  const fallbackImage = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';

  if (variant?.image?.url) {
    return variant.image.url;
  }

  if (product?.images?.nodes?.length > 0 && product.images.nodes[0].url) {
    return product.images.nodes[0].url;
  }

  return fallbackImage;
};

function createFormDataFromIds(idArray, element) {
    const section = element.getAttribute('data-section');
    if (element.getAttribute('data-planid')) {
        return {
        items: idArray.map(id => ({
            id: id,
            quantity: 1,
            selling_plan: element.getAttribute('data-planid')
        }))
        };
    }

    const items = idArray.map(id => {
        const baseItem = { id, quantity: 1 };

        const sectionTypeMap = {
        section_basics: "tangent-basics-product",
        section_essentials: "tangent-essentials-product",
        section_works: "tangent-works-product"
        };

        if (sectionTypeMap[section]) {
        baseItem.properties = {
            _type: sectionTypeMap[section],
            _variantIds: idArray
        };
        }

        return baseItem;
    });
    
    return { items };
}

function addToCart(element){ 
    const formData = createFormDataFromIds([element.id], element);
    addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
    const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list);
    if(formData){
        addToCartApi(formData, element);
    } 
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

function addToCartApi(payload, element){ 
    element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`;
    
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    })
    .then(async (response) => {
        const data = await response.json();

        if (!response.ok) {
            throw data;
        }
         if (element.getAttribute('data-planid')) {
            element.innerHTML = default_subscribtionAddedText;
         }
         else{
             element.innerHTML = default_addedToCartText;
         }
       
        element.classList.add("added-to-cart-style"); 

        setTimeout(updateCartCount, 100);
        
        element.dispatchEvent(
        new CustomEvent("cart-drawer:refresh", {
            detail: { response: response },
            bubbles: true,
            composed: true
        })
        );
        return data;
    })
    .catch((error) => {
        if (error && error.status) {
        const message = error.message || "Something went wrong";

        element.innerHTML = "Add to Cart";
        element.classList.remove("added-to-cart-style");

        showCartError(element, message);
        } 

        element.dispatchEvent(
        new CustomEvent("cart-drawer:refresh", {
            detail: { response: error },
            bubbles: true,
            composed: true
        })
        );
    });
}

function updateCartCount() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count;
      const countEl = document.querySelector('[data-cart-count]');
      const bubble = document.querySelector('[data-cart-count-bubble]');
      // update count
      if (countEl) {
        countEl.textContent = count;
      }

      // show/hide bubble
      if (bubble) {
        if (count > 0) {
          bubble.classList.remove('hide');   
          bubble.style.display = 'flex';   
        } else {
          bubble.classList.add('hide');
        }
      }
    })
    .catch(err => console.error('Cart fetch error:', err));
}

function showCartError(targetElement, message) {
  if (!targetElement) return;

  const parent = targetElement.parentNode;

  // Remove existing message
  const existing = parent.querySelector('.tangent-cart-error-msg');
  if (existing) existing.remove();

  const el = document.createElement('p');
  el.textContent = message;
  el.className = 'tangent-cart-error-msg';

  targetElement.insertAdjacentElement('afterend', el);

  // Store timeout on element to prevent multiple timers
  if (targetElement._errorTimeout) {
    clearTimeout(targetElement._errorTimeout);
  }

  targetElement._errorTimeout = setTimeout(() => {
    const msg = parent.querySelector('.tangent-cart-error-msg');
    if (msg) msg.remove();
  }, 4000);
}

function addResponseTextBelow(element, response){
  const textEl = document.createElement('p');
  textEl.textContent = response.message;
  element.insertAdjacentElement('afterend', textEl);
}

function extractSellingId(id){
  return id.replace("gid://shopify/SellingPlan/", "");
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    return section_container;
}

function createSectionAddAllToCart(section_name) {
    const add_all_to_cart_button = document.createElement("button");
    add_all_to_cart_button.id = section_name;
    add_all_to_cart_button.classList.add("section_add_all_to_cart", section_name+"_add_all_to_cart", "btn");
    add_all_to_cart_button.innerHTML = default_add_all_to_cart_text;

    // Enabling listener
    add_all_to_cart_button.addEventListener(
        'click',
        function () { addAllTocartFunction(add_all_to_cart_button); },
        false
    );
    return add_all_to_cart_button;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Product Section Creation
function createProductSection(product_sections, text_sections) {

    for (const section_name in product_sections) {

        let items = product_sections[section_name];
        
        let hasMultiple = items.length > 1;
        if(selectedRegimen==="regimen_6"){
            hasMultiple = false;
        }

        const maxItems = selectedRegimen === "regimen_6" ? 1 : 2;

        if (items.length > maxItems) {
            items.splice(maxItems);
        }
        items.forEach((item, index) => {

            const currentSectionName = hasMultiple
                ? `${section_name}_${index}`
                : section_name;

            const section_container = createSectionContainer(currentSectionName);

            // Add text section
            if (text_sections) {
                createTextSectionBeforeProducts(
                    text_sections,
                    section_container,
                    section_name
                );
            }

            // Add product grid
            section_container.appendChild(
                addSectionProductGridContainer(currentSectionName)
            );

            // Append section
            if (section_name !== "section_full_set") {
                tangentProductSectionsWrapper.appendChild(section_container);
            } else {
                document
                    .getElementById("tangent-fullset-product")
                    .appendChild(section_container);
            }
        });
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

function createSectionTextDiv(sectionName, textSections) {

    let sectionTextDiv = document.createElement("div");

    sectionTextDiv.id = `${sectionName}_text_container`;

    sectionTextDiv.classList.add("section_text_container");
    sectionTextDiv.classList.add(`${sectionName}_text_container`);

    sectionTextDiv.innerHTML = textSections[sectionName].join(" ");

    return sectionTextDiv;
}

function appendSectionContainer(sectionName, sectionContainer) {

    const containerSelectorMap = {
        section_selfie: "#section_selfie_container_parent",
        section_video: "#tangent-video-section-container",
        section_routine_am: "#tangent_routine_am_content",
        section_routine_pm: "#tangent_routine_pm_content",
        section_footer:"#section_footer_container_parent"
    };

    let targetContainer = tangentOtherSectionsWrapper;

    if (containerSelectorMap[sectionName]) {
        const targetSelector = containerSelectorMap[sectionName];
        targetContainer = document.querySelector(targetSelector);
    }

    targetContainer.appendChild(sectionContainer);
}
function createTextSection(productSections, textSections) {
    Object.keys(textSections).forEach(sectionName => {

        // Skip if product section already exists
        if (productSections?.[sectionName]) return;

        // Skip empty text
        const sectionText = textSections[sectionName];
        if (!sectionText) return;

        const sectionContainer = createSectionContainer(sectionName);

        const sectionTextDiv = createSectionTextDiv(
            sectionName,
            textSections
        );

        sectionContainer.appendChild(sectionTextDiv);

        appendSectionContainer(
            sectionName,
            sectionContainer
        );
    });
}

// Enabling button listeners
function enableButtonListener(){
    document.querySelectorAll('.tangent_tab').forEach(tab => {
        tab.addEventListener('click', () => {
            document.querySelectorAll('.tangent_tab').forEach(t => t.classList.remove('active'));
            document.querySelectorAll('.tangent_tab_content').forEach(c => c.classList.remove('active'));

            tab.classList.add('active');
            document.getElementById(tab.dataset.tab).classList.add('active');
        });
    });

    document.querySelectorAll(
        '.tangent-product-add-btn-wrapper, .tangent-product-add-btn-wrapper-subscribe'
    ).forEach(function(btn) {
        btn.onclick = function () {
            addToCart(this);
        };
    });

    document.addEventListener("click", (e) => {
        const button = e.target.closest(".how-to-use-toggle");
        if (!button) return;

        const text = document.getElementById(button.dataset.target);

        const expanded = text.classList.toggle("expanded");

        button.textContent = expanded
            ? "Read Less"
            : "Read More";
    });

     document
        .querySelectorAll(".how-to-use-product-description")
        .forEach(container => {
            const text = container.querySelector(".how-to-use-text");
            const button = container.querySelector(".how-to-use-toggle");

            if (!text || !button) return;

            // Force browser layout calculation
            requestAnimationFrame(() => {
                if (text.scrollHeight > text.offsetHeight) {
                    button.style.display = "inline-block";
                }
            });
        });
}

// Show elements after response data loads
function loadElementsOnResponseData(){
    const elements = document.querySelectorAll('.load-on-data');
    if (!elements.length) return;

    elements.forEach(el => {
        el.style.display = "block";
    });
}

function setElementDisplay(elementId, display) {
    const el = document.querySelector("#" + elementId);
    if (el) {
        el.style.display = display;
    }
}

function setSelfieId(id) {
    tangent_selfie_id = id;
}

function getSelfieId() {
    return tangent_selfie_id;
}

// Called on image on load function
function drawOnCanvas() {
    if (getSelfieId() != null) {

        var selfie_canvas = document.querySelector('#selfie_canvas');
        var selfie_canvas_ctx = selfie_canvas.getContext('2d');

        selfie_canvas.addEventListener('click', function (e) {
            getCursorPosition(selfie_canvas, e)
        });

        var canvas_img = document.querySelector('#canvas_img');
        setCanvasDimensions(selfie_canvas, canvas_img);

        var prop = getImageSize(canvas_img.naturalWidth);

        drawDarkCircleContours(selfie_canvas_ctx, tangent_facemap_data["dark_circles"], getDarkCircleBlur(prop));
        drawWrinkleContours(selfie_canvas_ctx, tangent_facemap_data["wrinkles"], getWrinkleLineWidth(prop));
        drawRosaceaContours(selfie_canvas_ctx, tangent_facemap_data["rosacea"], getRosaceaBlur(prop));
        drawTextureContours(selfie_canvas_ctx, tangent_facemap_data["texture"], getTextureLineWidth(prop));
        drawDarkSpotsContours(selfie_canvas_ctx, tangent_facemap_data["darkspots"], getDarkSpotsLineWidth(prop));
        drawAcneContours(selfie_canvas_ctx, tangent_facemap_data["acne"], getAcneLineWidth(prop));
    }
}

const setCanvasDimensions = (selfie_canvas, canvas_img) => {
    selfie_canvas.width = canvas_img.naturalWidth;
    selfie_canvas.height = canvas_img.naturalHeight;
}

const getImageSize = (imgWidth) => {
    var prop = imgWidth / 400;
    return prop;
}

const getDarkCircleBlur = (prop) => {
    if (prop < 1) {
        return 'blur(1px)';
    }
    else if (prop < 1.5) {
        return 'blur(2px)';
    }
    else if (prop < 2) {
        return 'blur(4px)';
    }
    else if (prop < 3) {
        return 'blur(7px)';
    }
    else if (prop < 4) {
        return 'blur(12px)';
    }
    else {

    }
}

const getRosaceaBlur = (prop) => {
    if (prop < 1) {
        return 'blur(4px)';
    }
    else if (prop < 1.5) {
        return 'blur(4px)';
    }
    else if (prop < 2) {
        return 'blur(5px)';
    }
    else if (prop < 3) {
        return 'blur(13px)';
    }
    else if (prop < 4) {
        return 'blur(18px)';
    }
    else {
        console.log("out of bound props - Rosacea");
    }
}

const getAcneLineWidth = (prop) => {
    if (prop < 0.5) {
        return 2;
    }
    else if (prop < 1) {
        return 4;
    }
    else if (prop < 1.5) {
        return 7;
    }
    else if (prop < 2) {
        return 10;
    }
    else if (prop < 3) {
        return 14;
    }
    else if (prop < 4) {
        return 15;
    }
    else {
        console.log("out of bound props - Acne");
    }
}

const getDarkSpotsLineWidth = (prop) => {
    if (prop < 1) {
        return 1;
    }
    else if (prop < 1.5) {
        return 6;
    }
    else if (prop < 2) {
        return 6;
    }
    else if (prop < 3) {
        return 14;
    }
    else if (prop < 4) {
        return 15;
    }
    else {
        console.log("out of bound props - DarkSpots");
    }
}

const getTextureLineWidth = (prop) => {
    if (prop < 0.5) {
        return 2;
    }
    else if (prop < 1) {
        return 3;
    }
    else if (prop < 1.5) {
        return 6;
    }
    else if (prop < 2) {
        return 10;
    }
    else if (prop < 3) {
        return 14;
    }
    else if (prop < 4) {
        return 16;
    }
    else {
        return 20;
    }
}

const getWrinkleLineWidth = (prop) => {
    if (prop < 1) {
        return 4;
    }
    else if (prop < 1.5) {
        return 6;
    }
    else if (prop < 2) {
        return 10;
    }
    else if (prop < 3) {
        return 15;
    }
    else if (prop < 4) {
        return 30;
    }
    else {
        console.log("out of bound props - Wrinkle");
    }
}

const drawDarkCircleContours = (context, eye_contours, filter) => {
    context.filter = filter;
    context.fillStyle = 'rgba(28, 30, 82, 0.3)';
    drawContours(context, eye_contours, true, false);
}

const drawWrinkleContours = (context, wrinkle_contours, lineWidth) => {
    context.fillStyle = 'rgba(24, 96, 3, 0.5)';
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(24, 96, 3, 0.5)";
    drawContours(context, wrinkle_contours, true, true);
}

const drawRosaceaContours = (context, eye_contours, filter) => {
    context.filter = filter;
    context.fillStyle = 'rgba(206, 66, 66, 0.5)';
    drawContours(context, eye_contours, true, false);
}

const drawTextureContours = (context, eye_contours, lineWidth) => {
    context.lineWidth = lineWidth;
    context.filter = 'none';
    context.strokeStyle = "rgba(186, 111, 223, 0.5)";
    drawContours(context, eye_contours, false, true);
}

const drawDarkSpotsContours = (context, darkspots_contours, lineWidth) => {
    context.fillStyle = 'rgba(81, 212, 191, 0.4)';
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(81, 212, 191, 0.4)";
    drawContours(context, darkspots_contours, true, false);
}

const drawAcneContours = (context, acne_contours, lineWidth) => {
    context.fillStyle = 'rgba(234, 220, 96, 0.4)';
    context.lineWidth = lineWidth;
    context.strokeStyle = "rgba(234, 220, 96, 0.4)";
    drawContours(context, acne_contours, true, false);
}

const drawContours = (context, contours, fill, stroke) => {
    for (let i = 0; i < contours.length; i++) {
        drawContour(context, contours[i], fill, stroke)
    }
}

const drawContour = (context, contour_coordinates, fill = false, stroke = false) => {
    context.beginPath();
    for (let i = 0; i < contour_coordinates.length; i++) {
        let point = contour_coordinates[i]
        if (i == 0) {
            context.moveTo(point[0], point[1]);
        } else {
            context.lineTo(point[0], point[1]);
        }
    }
    context.closePath();
    if (fill) context.fill();
    if (stroke) context.stroke();
}

// Getting current canvas click position
function getCursorPosition(canvas, event) {

    const ctx = canvas.getContext('2d');
    const bb = canvas.getBoundingClientRect();
    var point = {
        _x: Math.floor((event.clientX - bb.left) / bb.width * canvas.width),
        _y: Math.floor((event.clientY - bb.top) / bb.height * canvas.height)
    }

    var skin_conditions = ["acne", "darkspots", "wrinkles", "dark_circles", "rosacea"];
    var click_found = false;
    for (var sc = 0; sc < skin_conditions.length; sc++) {
        if (isPointInsidePoligon(point, tangent_facemap_data[skin_conditions[sc]])) {
            // openConditionMessage(canvas, skin_conditions[sc]);
            click_found = true;
            break;
        }
    }
    if (!click_found) {
        tangent_condition_message_popoup.style.display = "none";
        console.log("no condition click");
    }
}

function openConditionMessage(canvas, condition) {
    tangent_condition_message_popoup.innerHTML = condition_text_mapping[condition];
    let rect = canvas.getBoundingClientRect();
    var point = {
        _x: event.clientX - rect.left,
        _y: event.clientY - rect.top
    }

    // Positioning Popup
    Object.assign(
        tangent_condition_message_popoup.style,
        {
            display: "block",
            left: (point._x) + "px",
            top: (point._y) + "px"
        }
    );
}


// Check whether click is inside condition points
function isPointInsidePoligon(pt, points_list) {
    // https://stackoverflow.com/a/29915728/960654
    // ray-casting algorithm based on
    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html

    var x = pt._x,
        y = pt._y

    var inside = false;
    for (var c = 0; c < points_list.length; c++) {
        var points = points_list[c];
        for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
            var xi = points[i][0],
                yi = points[i][1]
            var xj = points[j][0],
                yj = points[j][1]

            var intersect =
                yi > y != yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
            if (intersect) inside = !inside
        }
    }
    return inside
}